"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalDialog = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactBootstrap = require("react-bootstrap");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
class ModalDialog extends _react.default.Component {
  constructor(props) {
    super(props);
    this.onHide = this.onHide.bind(this);
    this.renderBody = this.renderBody.bind(this);
  }
  onHide(e) {
    const {
      onHide
    } = this.props;
    onHide(e);
    this.removeStylingFromBody();
  }
  removeStylingFromBody() {
    const {
      backdropColor
    } = this.props;
    document.body.classList.remove("modal-backdrop-color-" + backdropColor);
  }

  // eslint-disable-next-line class-methods-use-this
  renderBody() {
    return null;
  }
  render() {
    const {
      className,
      isFullWidth,
      show,
      backdropColor,
      modalId
    } = this.props;
    const setClassName = (0, _classnames.default)(className, isFullWidth ? "full-page-overlay" : "");
    if (show) {
      document.body.classList.add("modal-backdrop-color-" + backdropColor);
    }
    return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal, {
      id: modalId,
      animation: false,
      show: show,
      onHide: this.onHide,
      className: setClassName
    }, this.renderBody());
  }
}
exports.ModalDialog = ModalDialog;
ModalDialog.propTypes = {
  modalId: _propTypes.default.string.isRequired,
  show: _propTypes.default.bool.isRequired,
  onHide: _propTypes.default.func.isRequired,
  className: _propTypes.default.string.isRequired,
  isFullWidth: _propTypes.default.bool,
  backdropColor: _propTypes.default.string
};
ModalDialog.defaultProps = {
  isFullWidth: true,
  backdropColor: "white"
};